import { LicenseInfo } from '@mui/x-license';

import { Config } from '../Config';

export const initMuiPro = () => {
  LicenseInfo.setLicenseKey(Config.muiLicenseKey);
};
